/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-19 10:56:09
 **/
/* eslint @typescript-eslint/no-explicit-any: 0 */

import { DataStorePrivate } from "./private";

const SessionData: StorageType = {
	get(key: string, defValue: any = false, isSecure = false) {
		return DataStorePrivate.get(sessionStorage, key, defValue, isSecure);
	},
	set(key: string, value: any, isSecure = false) {
		DataStorePrivate.set(sessionStorage, key, value, isSecure);
	},
	remove(key: string) {
		DataStorePrivate.remove(sessionStorage, key);
	},
	clear(keys: string[]) {
		for (const key in keys) {
			DataStorePrivate.remove(sessionStorage, key);
		}
	}
};
export default SessionData;
